module.exports = __webpack_public_path__ + "img/wq_subject.3ee2082e.png";